/**
 * Environment Configuration
 * 
 * This file manages environment-specific configuration for the application.
 * It automatically detects whether the app is running in development or production
 * and provides the appropriate configuration values.
 */

type Environment = 'development' | 'production';

interface ConvexConfig {
  url: string;
}

interface AppConfig {
  convex: ConvexConfig;
}

const environment: Environment = import.meta.env.MODE === 'production' ? 'development'/*'production'*/ : 'development';

const config: Record<Environment, AppConfig> = {
  development: {
    convex: {
      url: 'https://hip-gazelle-676.convex.cloud',
    },
  },
  production: {
    convex: {
      url: 'https://hip-gazelle-676.convex.cloud',
    },
  },
};

export const appConfig = config[environment];
export const currentEnvironment = environment;
